import { useState, useEffect } from 'react';
import api from '../api';

/**
 * Hook to check if chat feature is enabled
 */
export const useChatEnabled = () => {
  const [chatEnabled, setChatEnabled] = useState(true); // Default to true
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkChatEnabled = async () => {
      try {
        const response = await api.get('/admin/public/features/chat-enabled');
        setChatEnabled(response.data.enabled);
      } catch (error) {
        // Default to enabled on error
        setChatEnabled(true);
      } finally {
        setLoading(false);
      }
    };

    checkChatEnabled();
  }, []);

  return { chatEnabled, loading };
};

